import { useState } from 'react';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import ServiceHistoryList from './components/ServiceHistoryList';
import ServiceRecordDetail from './components/ServiceRecordDetail';
import ServiceUpcomingList from './components/ServiceUpcomingList';
import { LOG_SERVICE_BUTTON_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, OnSelectRecord, Props } from './types';

import styles from './styles.module.scss';

const TabPanelService: FunctionComponent<Props> = ({
    className = '',
    drone,
    isAdmin,
    onEditRecord,
    onOpenLogService,
    onVoidRecord,
    records,
    serviceIntervals,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const [selectedRecordId, setSelectedRecordId] = useState<string | null>(null);
    // Defensive resolve — a dangling id (record no longer in the list) falls back
    // to the list view instead of rendering a detail for a missing record.
    const selectedRecord = selectedRecordId
        ? (records.find(record => record.id === selectedRecordId) ?? null)
        : null;

    const handleSelectRecord: OnSelectRecord = ({ recordId }) => setSelectedRecordId(recordId);

    const handleBack = () => setSelectedRecordId(null);

    return (
        <VerticalContainer className={`${styles.tabPanelService} ${className}`} testId={testId}>
            {selectedRecord ? (
                <ServiceRecordDetail
                    isAdmin={isAdmin}
                    onBack={handleBack}
                    onEditRecord={onEditRecord}
                    record={selectedRecord}
                    serviceIntervals={serviceIntervals}
                />
            ) : (
                <>
                    <ServiceUpcomingList drone={drone} serviceIntervals={serviceIntervals} />

                    <ServiceHistoryList
                        isAdmin={isAdmin}
                        onSelectRecord={handleSelectRecord}
                        onVoidRecord={onVoidRecord}
                        records={records}
                    />

                    <Wrapper
                        className={styles.logServiceButton}
                        onClick={onOpenLogService}
                        testId={LOG_SERVICE_BUTTON_TEST_ID}>
                        {t.LOG_SERVICE}
                    </Wrapper>
                </>
            )}
        </VerticalContainer>
    );
};

export default TabPanelService;
